(() => {
  'use strict';

  // Shrine builds multi-item product forms from variant IDs. Attach the existing
  // promotional identity to the gift line itself, not to the purchased trackers.
  document.addEventListener('formdata', (event) => {
    const productForm = event.target.closest('product-form.main-product-form');
    if (!productForm) return;
    const root = document.getElementById(`quantity-breaks-${productForm.dataset.section}`);
    if (!root) return;
    const gifts = [...root.querySelectorAll('.quantity-break__upsell[data-type="gift"][data-selected="true"]')];
    if (!gifts.length) return;
    const formData = event.formData;
    for (const [key, value] of [...formData.entries()]) {
      const match = key.match(/^items\[(\d+)\]\[id\]$/);
      if (!match) continue;
      const gift = gifts.find(item => item.dataset.product === String(value));
      if (!gift) continue;
      const prefix = `items[${match[1]}][properties]`;
      formData.set(`${prefix}[_easytag_free_gift]`, 'true');
      formData.set(`${prefix}[_easytag_gift_offer]`, gift.dataset.giftOffer || '');
    }
  }, true);

  // The full-cart update finishes before Shrine refreshes the separate drawer.
  // Its empty-cart focus target can therefore be null (confirmed in the browser),
  // or inside a closed drawer. Neither is a valid modal focus destination.
  // Keep Shrine's focus handling unchanged for every available, open modal.
  customElements.whenDefined('cart-items').then(() => {
    if (!document.querySelector('cart-items') || typeof window.trapFocus !== 'function') return;
    const nativeTrapFocus = window.trapFocus;
    window.trapFocus = function(container, ...args) {
      if (!container) return;
      const drawer = container.closest('cart-drawer');
      if (drawer && !drawer.classList.contains('active')) return;
      return nativeTrapFocus.call(this, container, ...args);
    };
  });

  // Shopify rounds the order-discount allocation down to whole currency units
  // (pence/cents). Round the displayed remainder up to match checkout. Retain
  // Shrine's formatting, variant updates, compare prices and subscription code.
  const currencyAmount = amount => Math.ceil(Number(amount) - 1e-7);
  customElements.whenDefined('quantity-breaks').then(() => {
    const proto = customElements.get('quantity-breaks').prototype;
    if (proto.easytagRoundingReady) return;
    const labelPrices = proto.updateLabelPrices;
    const pdpPrices = proto.updateDisplayedPdpPrices;
    if (typeof labelPrices !== 'function' || typeof pdpPrices !== 'function') return;
    proto.easytagRoundingReady = true;
    proto.updateLabelPrices = function(label, quantity, price, comparePrice) {
      return labelPrices.call(this, label, quantity, currencyAmount(price), comparePrice);
    };
    proto.updateDisplayedPdpPrices = function(...args) {
      Object.values(this.offerPrices || {}).forEach(offer => {
        if (Number.isFinite(offer.price)) offer.price = currencyAmount(offer.price);
      });
      return pdpPrices.apply(this, args);
    };
    document.querySelectorAll('quantity-breaks').forEach(root => {
      if (root.updatePrices && typeof root.updateInnerPrices === 'function') root.updateInnerPrices();
      if (root.updatePdpPrices) root.updateDisplayedPdpPrices();
    });
  });
})();
